import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-select_work",
  "use": "vab-icon-select_work-usage",
  "viewBox": "0 0 21 22",
  "content": "<symbol viewBox=\"0 0 21 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-select_work\">\n<path d=\"M15.75 8.75H17.25V14.75C17.25 15.575 16.575 16.25 15.75 16.25H5.25C4.425 16.25 3.75 15.575 3.75 14.75V7.25C3.75 6.425 4.425 5.75 5.25 5.75H14.25V7.25H5.25V14.75H15.75V8.75ZM14.25 8.75H6.75V10.25H14.25V8.75ZM12.75 11.75H6.75V13.25H12.75V11.75ZM15.75 7.25H17.25V5.75H15.75V7.25Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol